export const toitplatTranslations = {
  // Hero
  breadcrumb_home: 'Accueil',
  breadcrumb_current: 'Toit plat / Membrane élastomère',
  hero_h1: 'Toit plat à Lévis : membrane élastomère pose et réfection',
  hero_subtitle: 'Spécialistes du bicouche soudé. Étanchéité garantie 15 ans, pose en 1 journée.',
  hero_cta: 'Demander ma soumission toit plat',
  hero_stat_1: '+200 toits plats posés',
  hero_stat_2: 'Garantie 15 ans',
  hero_stat_3: 'Bicouche soudé',

  // Pour qui
  pourqui_h2: 'À qui s\u0026rsquo;adresse un toit plat en membrane élastomère ?',
  pourqui_1: 'Duplex, triplex et plex de Lévis',
  pourqui_2: 'Condos et immeubles à logements',
  pourqui_3: 'Maisons modernes à toit plat ou faible pente',
  pourqui_4: 'Garages, annexes, vérandas',
  pourqui_5: 'Commerces et bâtiments industriels légers',

  // Système bicouche
  bicouche_h2: 'Comment fonctionne une membrane élastomère bicouche',
  bicouche_text: 'Le bicouche soudé est le standard de l\u0026rsquo;industrie depuis 40 ans. Deux couches de membrane bitumineuse fusionnées à la torche créent une étanchéité parfaite, résistante au gel, à la grêle et aux UV.',
  bicouche_couche_1: 'Pontage de bois',
  bicouche_couche_1_sub: 'existant ou neuf',
  bicouche_couche_2: 'Isolant rigide',
  bicouche_couche_2_sub: 'polyiso ou laine de roche',
  bicouche_couche_3: 'Membrane de base',
  bicouche_couche_3_sub: 'collée ou clouée',
  bicouche_couche_4: 'Membrane de finition',
  bicouche_couche_4_sub: 'soudée au chalumeau',
  bicouche_couche_5: 'Granules de protection UV',
  bicouche_couche_5_sub: 'surface finale',

  // Prix
  prix_h2: "Prix d\u0026rsquo;un toit plat en membrane élastomère à Lévis 2026",
  prix_table_type: 'Type de toit',
  prix_table_price: 'Prix indicatif',
  prix_row1_type: 'Toit garage / annexe (200–400 pi²)',
  prix_row1_price: '3 500 $ – 6 500 $',
  prix_row2_type: 'Petit toit plat résidentiel (500–800 pi²)',
  prix_row2_price: '7 500 $ – 13 000 $',
  prix_row3_type: 'Duplex moyen (1 000–1 500 pi²)',
  prix_row3_price: '13 000 $ – 22 000 $',
  prix_row4_type: 'Triplex / immeuble (1 500–2 500 pi²)',
  prix_row4_price: '22 000 $ – 35 000 $',
  prix_note: 'Prix incluent retrait ancienne membrane, isolant si requis, drains, solins. Soumission précise après inspection.',

  // Pourquoi nous
  pourquoi_h2: 'Pourquoi confier votre toit plat à nos couvreurs partenaires',
  pourquoi_1_title: 'Soudeurs certifiés à la torche thermique',
  pourquoi_1_desc: 'Formation continue en soudure membrane et manipulation du chalumeau. Pas de risque d\u0026rsquo;incendie.',
  pourquoi_2_title: 'Membranes Soprema et IKO',
  pourquoi_2_desc: 'Les deux leaders mondiaux de l\u0026rsquo;étanchéité. Matériaux certifiés pour le climat québécois.',
  pourquoi_3_title: 'Équipement sécuritaire CNESST',
  pourquoi_3_desc: 'Harnais, ligne de vie, système anti-chute. Travail propre, sécuritaire, conforme à la loi.',
  pourquoi_4_title: 'Garantie écrite 15 ans',
  pourquoi_4_desc: "Sur l'étanchéité, la main-d'œuvre et les matériaux. Signée, datée, remise en main propre.",

  // Process
  process_h2: 'Notre processus, étape par étape',
  process_step1_num: '1',
  process_step1_title: 'Inspection toit existant',
  process_step1_sub: 'gratuit, 48h',
  process_step1_desc: 'On mesure, on prend des photos, on évalue la structure et les drains existants.',
  process_step2_num: '2',
  process_step2_title: 'Soumission détaillée',
  process_step2_desc: 'Options de membrane, prix par superficie, délais. Signée si acceptée.',
  process_step3_num: '3',
  process_step3_title: 'Retrait ancienne membrane',
  process_step3_desc: "On enlève l'ancienne membrane jusqu'au pontage, on inspecte et répare la structure si nécessaire.",
  process_step4_num: '4',
  process_step4_title: 'Pose isolant + membrane',
  process_step4_sub: '1–2 jours',
  process_step4_desc: 'Isolant rigide, membrane de base, membrane de finition soudée à la torche. Solins et drains scellés.',
  process_step5_num: '5',
  process_step5_title: 'Test étanchéité + garantie',
  process_step5_desc: "Vérification des joints et des drains. Remise de la garantie écrite 15 ans et rapport photo.",

  // Témoignage
  temoin_text: "On possède un duplex sur la rue Saint-Joseph depuis 8 ans. L'ancien proprio avait mis une membrane cheap qui commençait à fissurer partout. Au printemps 2025, le locataire du haut a signalé une tache au plafond de la cuisine. Un couvreur partenaire de Couvreur-Lévis.com est venu inspecter en 2 jours. Ils ont trouvé 4 fissures principales et un drain partiellement bouché. Ils nous ont proposé un bicouche Soprema avec garantie 15 ans. Le chantier a duré 1 journée complète — on n'a pas eu à reloger personne. L'équipe a tout nettoyé, même les débris dans les gouttières. Aujourd'hui, zéro fuite, zéco souci. La toiture est belle, uniforme, et on sait qu'elle va durer.",
  temoin_name: 'Pierre L.',
  temoin_location: 'Lévis centre',
  temoin_project: 'Réfection toit plat duplex, 1 200 pi², août 2025',

  // FAQ
  faq_h2: 'Questions fréquentes sur le toit plat et la membrane élastomère',
  faq_q1: 'Combien de temps dure une membrane élastomère ?',
  faq_a1: 'Une membrane élastomère bicouche de qualité dure entre 25 et 35 ans dans notre climat québécois. La durée dépend de la qualité de la soudure, de l\u0026rsquo;épaisseur de la membrane (3mm ou 4mm), et de l\u0026rsquo;entretien régulier des drains. Soprema et IKO offrent des garanties fabricant de 15 à 25 ans sur leurs membranes premium.',
  faq_q2: 'Faut-il enlever l\u0026rsquo;ancienne membrane ou peut-on poser dessus ?',
  faq_a2: 'Généralement, on recommande l\u0026rsquo;enlèvement complet pour inspecter le pontage et l\u0026rsquo;isolant sous-jacent. Si l\u0026rsquo;ancienne membrane est encore saine et adhérente, on peut parfois poser une nouvelle couche par-dessus (technique du surtoiture). On évalue ça lors de l\u0026rsquo;inspection gratuite.',
  faq_q3: 'Quelle est la pente minimum pour un toit plat ?',
  faq_a3: 'Un toit plat n\u0026rsquo;est jamais réellement plat — il a une pente minimale de 2% (environ 1/4 pouce par pied) pour permettre l\u0026rsquo;écoulement de l\u0026rsquo;eau vers les drains. Si votre toit n\u0026rsquo;a pas cette pente, on peut la corriger avec des cales d\u0026rsquo;isolant lors de la réfection.',
  faq_q4: 'Peut-on installer en hiver à Lévis ?',
  faq_a4: 'La membrane élastomère est plus permissive que le bardeau pour les températures froides, mais on évite de souder sous -5°C car l\u0026rsquo;adhérence est réduite. En hiver, on fait des réparations d\u0026rsquo;urgence et des inspections. Les réfections complètes sont planifiées d\u0026rsquo;avril à novembre.',
  faq_q5: 'Quelle différence entre élastomère, TPO et EPDM ?',
  faq_a5: "L'élastomère (bitumineuse modifiée) est le standard au Québec depuis 40 ans — résistante au gel, facile à réparer, et les couvreurs locaux la maîtrisent parfaitement. Le TPO (membrane plastique blanche) est plus récent et écologique, mais moins répandu ici. L'EPDM (caoutchouc) est utilisé sur les grands immeubles commerciaux. Pour un duplex ou triplex à Lévis, le bicouche élastomère soudé reste le meilleur rapport qualité-prix.",

  // CTA Final
  cta_h2: 'Votre toit plat à Lévis mérite un vrai spécialiste',
  cta_subtitle: 'Inspection gratuite, soumission claire, garantie 15 ans.',
  cta_button: 'Obtenir ma soumission',
  cta_phone: '418-476-9950',

  // Formulaire
  form_h2: 'Demandez votre soumission gratuite',
  form_subtitle: 'Remplissez le formulaire — on vous rappelle en 2h ouvrables.',
  form_success: 'Soumission envoyée !',
  form_success_sub: 'On vous rappelle dans les 2 prochaines heures ouvrables. Merci de nous faire confiance.',
  form_name_label: 'Nom complet',
  form_name_placeholder: 'Votre nom',
  form_phone_label: 'Téléphone',
  form_phone_placeholder: '418-476-9950',
  form_email_label: 'Courriel',
  form_email_placeholder: 'votre@email.com',
  form_surface_label: 'Superficie approximative (pi²)',
  form_surface_placeholder: 'ex: 1 200',
  form_type_label: 'Type de bâtiment',
  form_type_select: 'Sélectionnez un type',
  form_message_label: 'Description du projet',
  form_message_placeholder: "Décrivez votre toit plat : superficie, problèmes observés, âge de la membrane actuelle...",
  form_char_count: '/500',

  // Header/Footer shared
  nav_home: 'Accueil',
  nav_services: 'Services',
  nav_about: 'À propos',
  nav_quote: 'Soumission',
  phone_number: '418-476-9950',
  cta_quote: 'Soumission gratuite',
  footer_brand: 'Couvreur-Lévis.com',
  footer_address: 'Lévis, QC, Canada',
  footer_email: 'contact@couvreur-levis.com',
  footer_services_title: 'Services',
  footer_link_refaction: 'Réfection toiture',
  footer_link_repair: 'Réparation',
  footer_link_flat: 'Toit plat',
  footer_link_metal: 'Tôle et métal',
  footer_link_inspection: 'Inspection',
  footer_links_title: 'Liens',
  footer_link_about: 'À propos',
  footer_link_quote: 'Soumission',
  footer_link_legal: 'Mentions légales',
  footer_link_privacy: 'Politique de confidentialité',
  footer_link_blog: 'Blog',
  footer_copyright: '© 2026 Couvreur-Lévis.com. Tous droits réservés.',
  footer_hours_title: 'Heures',
  footer_hours_week: 'Lun–Ven : 7h00 – 18h00',
  footer_hours_weekend: 'Sam–Dim : 8h00 – 16h00',
};

export default toitplatTranslations;